<div class="map-view-toggle">
  <a
    [routerLink]="['/verhalen']"
    [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }"
    [routerLinkActive]="'button--tertiary'"
    class="button button--md"
  >
    <app-icon anchor="icon-grid"></app-icon>
    <span>{{ 'overzicht-weergave-lijst-tekst' | fromDictionary }}</span>
  </a>
  <a
    [routerLink]="['/verhalen/kaart']"
    [routerLinkActive]="'button--tertiary'"
    [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }"
    class="button button--md"
  >
    <app-icon anchor="icon-map"></app-icon>
    <span>{{ 'overzicht-weergave-kaart-tekst' | fromDictionary }}</span>
  </a>
</div>
